import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import checkCircle from '../../../assets/images/checkCircle.svg';
import { Row, Col } from 'react-bootstrap';

import LoadingComponent from '../../LoadingComponent';

import api from '../../../services/api';

export const ModalReportSuccess = ({ handleClose }) => {
  const [regionais, setRegionais] = useState([]);
  const [plantoes, setPlantoes] = useState([]);
  const [loading, setLoading] = useState(true);

  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header modal-report">
          <p>Relatório gerado</p>
        </div>
        <div className="dash-modal-body modal-report">
          <img src={checkCircle} alt="Icon" />
          <p>O download iniciará automaticamente em alguns instantes, aguarde.</p>
          {/* <LoadingComponent loading={loading} /> */}
        </div>
        <div className="dash-modal-footer">
          <button className="btn-save-shifts" onClick={() => handleClose()}>Ok</button>
        </div>
      </div>
    </div>
  );

}

export default ModalReportSuccess;